import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "quote-calculation"
}
const _hoisted_2 = {
  key: 0,
  class: "table-head-bottom"
}

import { ref, watch } from "vue";
import productsApi from "../api/products";
import { PET_TYPE, PRODUCT_GROUP } from "../store/variables";
import { ProductGroup } from "../classes/productGroup";
import { Product } from "../classes/product";
import { PetType } from "../classes/petType";
import { Breed } from "../classes/breed";
import FilterComponent from "./sections/FilterComponent.vue";
import TableColumnHeadComponent from "./sections/TableColumnHeadComponent.vue";
import HeadlineComponent from "./sections/HeadlineComponent.vue";
import TableHeadComponent from "./sections/TableHeadComponent.vue";
import TableContentComponent from "./sections/TableContentComponent.vue";
import { trackObject, trackEvent, trackInitial } from "../helper/tracking";
import { getSessionObject, setSessionEntry } from "../helper/session";
import { getFormattedDate, getFormattedParamDate } from "../helper/general";
import { useFocusVisible } from "frontend-component-templates/src/composables/useFocusVisible";
import { useZoomSticky } from "frontend-component-templates/src/composables/useZoomSticky";

interface Props {
  standalone?: boolean;
  productGroup?: number;
  petType?: number;
  petBirthday?: Date;
  petBreed?: number;
  petBreedIdentifier?: number;
  petName?: string;
  hideFilter?: boolean;
  liability?: boolean;
  sticky?: boolean;
  petTypes?: any;
  productGroupObject?: any;
  showBottomButtons?: boolean;
  tracking?: boolean;
  excludeProduct?: string;
  startDate?: Date;
  showHiddenRates?: boolean;
  baseUrl?: string;
  xApiKey?: string;
  clientKey?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteCalculation',
  props: {
    standalone: { type: Boolean, default: true },
    productGroup: { default: undefined },
    petType: { default: PET_TYPE.DOG },
    petBirthday: { default: null },
    petBreed: { default: null },
    petBreedIdentifier: { default: null },
    petName: { default: "" },
    hideFilter: { type: Boolean, default: false },
    liability: { type: Boolean, default: false },
    sticky: { type: Boolean, default: true },
    petTypes: { default: null },
    productGroupObject: { default: null },
    showBottomButtons: { type: Boolean, default: false },
    tracking: { type: Boolean, default: true },
    excludeProduct: { default: null },
    startDate: { default: null },
    showHiddenRates: { type: Boolean, default: false },
    baseUrl: { default: null },
    xApiKey: { default: null },
    clientKey: { default: null }
  },
  emits: ["selectProduct", "loadingComplete"],
  async setup(__props: any, { emit: __emit }) {

let __temp: any, __restore: any

const props = __props;

const emit = __emit;

productsApi.setApiKeys(props.baseUrl, props.xApiKey, props.clientKey);

const productGroup = ref<ProductGroup>();
const petTypes = ref<PetType[]>(
  props.petTypes || ((
  ([__temp,__restore] = _withAsyncContext(() => productsApi.getPetTypes())),
  __temp = await __temp,
  __restore(),
  __temp
))
);
const selectedDate = ref<Date>(
  props.petBirthday ? new Date(props.petBirthday) : undefined
);
const selectedPetType = ref<PetType>();
const selectedBreed = ref<Breed>();
const selectedProductGroupId = ref<number>(parseInt(props.productGroup));
const maxDate = ref<string>();
const minDate = ref<string>();
const showSpecificPetType = ref<number>();
const defaultProduct = ref<number>(2);
const highlightDefaultProduct = ref<boolean>(false);
const hideCombiFilter = ref(false);
const tksOpsCombi = ref<boolean>(false);
const excludeProduct = ref(props.excludeProduct);

checkDataAttributes();
checkSessionStorage();
useFocusVisible();
useZoomSticky();

function checkDataAttributes() {
  const quoteCalculationElement = document.getElementById("quote-calculation");
  if (quoteCalculationElement) {
    const dataProductGroup =
      quoteCalculationElement.getAttribute("data-product-group");
    const dataPetType = quoteCalculationElement.getAttribute("data-pet-type");
    const dataSelectedPetType = quoteCalculationElement.getAttribute(
      "data-selected-pet-type"
    );
    const dataDefaultProduct = quoteCalculationElement.getAttribute(
      "data-default-product"
    );
    const dataCombi = quoteCalculationElement.getAttribute("data-combi");
    const dataTksOps = quoteCalculationElement.getAttribute("data-tks-ops");

    if (!props.productGroup) {
      selectedProductGroupId.value =
        dataProductGroup === "OPS"
          ? PRODUCT_GROUP.OPS
          : dataProductGroup === "HPS"
          ? PRODUCT_GROUP.HPS
          : PRODUCT_GROUP.TKS;
    }

    if (dataPetType === "dog") {
      showSpecificPetType.value = PET_TYPE.DOG;
    } else if (dataPetType === "cat") {
      showSpecificPetType.value = PET_TYPE.CAT;
    }

    if (dataSelectedPetType) {
      setSelectedPetType(
        petTypes.value.find(
          (apiPetType) => apiPetType.ident === dataSelectedPetType
        )
      );
    }
    if (dataDefaultProduct) {
      defaultProduct.value = Number(dataDefaultProduct);
      highlightDefaultProduct.value = true;
    }
    if (dataCombi) {
      excludeProduct.value = "HPS24";
    }
    if (dataTksOps) {
      tksOpsCombi.value = true;
    }
  }
}

function checkSessionStorage() {
  if (sessionStorage.getItem("quoteCalculation")) {
    const sessionObject = getSessionObject();
    if (sessionObject.productGroupId === selectedProductGroupId.value) {
      if (
        sessionObject.petTypeId &&
        !document
          .getElementById("quote-calculation")
          ?.getAttribute("data-selected-pet-type")
      ) {
        setSelectedPetType(
          petTypes.value.find(
            (apiPetType) => apiPetType.id === sessionObject.petTypeId
          )
        );
      }
      if (sessionObject.breedId) {
        selectedBreed.value = selectedPetType.value?.breeds.find(
          (apiBreed) => apiBreed.identifier === sessionObject.breedId
        );
      }
      if (sessionObject.birthday) {
        selectedDate.value = new Date(sessionObject.birthday);
      }
    } else {
      setSelectedPetType(petTypes.value[0]);
      sessionStorage.removeItem("quoteCalculation");
    }
  } else if (
    !document
      .getElementById("quote-calculation")
      ?.getAttribute("data-selected-pet-type")
  ) {
    setSelectedPetType(petTypes.value[0]);
  }
}

if (props.petType) {
  setSelectedPetType(
    petTypes.value.find((apiPetType) => apiPetType.id === props.petType)
  );
}
if (props.petBreed) {
  selectedBreed.value = selectedPetType.value?.breeds.find(
    (apiBreed) => apiBreed.id === props.petBreed
  );
}
if (props.petBreedIdentifier) {
  selectedBreed.value = selectedPetType.value?.breeds.find(
    (apiBreed) => apiBreed.identifier === props.petBreedIdentifier
  );
}
;(
  ([__temp,__restore] = _withAsyncContext(() => getProductGroup(
  "tierart",
  selectedPetType.value?.name,
  props.productGroupObject
))),
  await __temp,
  __restore()
);
emit("loadingComplete");
setSessionEntry("petTypeId", selectedPetType.value?.id);
setSessionEntry("productGroupId", selectedProductGroupId.value);

async function showTariffs(selectedProductGroupId: number): void {
  hideCombiFilter.value = true;
  productGroup.value = await productsApi.getProductGroup(
    selectedProductGroupId,
    selectedPetType.value?.id,
    selectedBreed.value?.identifier,
    getFormattedDate(selectedDate.value),
    props.startDate
      ? new Date(props.startDate).toLocaleDateString("de-DE")
      : undefined,
    props.showHiddenRates
  );
  checkExcludedProduct();
  minDate.value = productGroup.value?.minDate;
  maxDate.value = productGroup.value?.maxDate;
  if (props.tracking) {
    trackObject(
      "view_item_list",
      productGroup.value?.products,
      selectedPetType.value,
      selectedBreed.value,
      getFormattedDate(selectedDate.value)
    );
  }
  setTimeout(() => {
    document
      .getElementsByClassName("quote-name")[0]
      .scrollIntoView({ behavior: "smooth" });
  });
}

function checkExcludedProduct() {
  if (excludeProduct.value) {
    const excludedProduct = productGroup.value.products.find(
      (item) => item.identifier === excludeProduct.value
    );
    if (excludedProduct) {
      productGroup.value.products = productGroup.value.products.filter(
        (item) =>
          item.identifier !== excludeProduct.value &&
          excludedProduct?.downGradeOptions?.indexOf(item.id) > -1
      );
    }
  }
}

function setSelectedPetType(petType: PetType): void {
  if (showSpecificPetType.value) {
    selectedPetType.value = petTypes.value.find(
      (petType) => petType.id === showSpecificPetType.value
    );
  } else {
    selectedPetType.value = petType;
  }
}

function selectProduct(product: Product): void {
  if (props.tracking) {
    trackObject(
      "select_item",
      [product],
      selectedPetType.value,
      selectedBreed.value,
      getFormattedDate(selectedDate.value)
    );
  }
  if (props.standalone) {
    const params = new URLSearchParams();
    params.set("pet", selectedPetType.value?.id);
    params.set("productGroup", selectedProductGroupId.value);
    params.set("product", product.id);
    if (selectedBreed.value?.id) {
      params.set("breed", selectedBreed.value.identifier);
    }
    if (selectedDate.value) {
      params.set("birthday", getFormattedParamDate(selectedDate.value));
    }
    if (window.self !== window.top) {
      params.set("brokerID", "50000005");
    }

    const targetUrl =
      process.env.VUE_APP_ORIGIN + "antrag2/#/1/tier/typ?" + params.toString();
    if (window.self !== window.top) {
      window.open(targetUrl);
    } else {
      window.location.href = targetUrl;
    }
  } else {
    emit("selectProduct", product);
  }
}

async function getProductGroup(
  trackingName?: string,
  trackingValue?: string | undefined,
  propProductGroup?: ProductGroup
): void {
  let productGroupTemp;
  if (propProductGroup) {
    productGroupTemp = new ProductGroup(propProductGroup);
  } else {
    productGroupTemp = await productsApi.getProductGroup(
      selectedProductGroupId.value,
      selectedPetType.value?.id,
      selectedBreed.value?.identifier,
      getFormattedDate(selectedDate.value),
      props.startDate
        ? new Date(props.startDate).toLocaleDateString("de-DE")
        : undefined,
      props.showHiddenRates
    );
  }
  if (props.liability) {
    productGroupTemp.products = productGroupTemp.products.slice(1);
    productGroup.value = productGroupTemp;
  } else {
    productGroup.value = productGroupTemp;
  }
  checkExcludedProduct();
  minDate.value = productGroup.value?.minDate;
  maxDate.value = productGroup.value?.maxDate;
  if (trackingName && trackingValue && props.tracking) {
    trackEvent(trackingName, trackingValue);
  }
  if (props.tracking) {
    trackObject(
      "view_item_list",
      productGroup.value?.products,
      selectedPetType.value,
      selectedBreed.value,
      getFormattedDate(selectedDate.value)
    );
  }
}

watch(
  () => selectedPetType.value,
  () => {
    selectedBreed.value = undefined;
    if (!tksOpsCombi.value) {
      getProductGroup("tierart", selectedPetType.value?.name);
      setSessionEntry("petTypeId", selectedPetType.value?.id);
    }
  }
);
watch(
  () => selectedBreed.value,
  () => {
    setSessionEntry("breedId", selectedBreed.value?.identifier);
    if (!tksOpsCombi.value) {
      getProductGroup("rasse", selectedBreed.value?.name);
    }
  }
);
watch(
  () => selectedDate.value,
  () => {
    setSessionEntry("birthday", selectedDate.value);
    if (!tksOpsCombi.value) {
      getProductGroup("alter", getFormattedDate(selectedDate.value));
    }
  }
);
watch(
  () => props.productGroup,
  () => {
    selectedProductGroupId.value = props.productGroup;
    getProductGroup(undefined, undefined, props.productGroupObject);
  }
);
if (props.tracking) {
  trackInitial(props.productGroup);
}

return (_ctx: any,_cache: any) => {
  return (productGroup.value && petTypes.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!props.hideFilter && selectedProductGroupId.value !== _unref(PRODUCT_GROUP).HPS)
          ? (_openBlock(), _createBlock(FilterComponent, {
              key: 0,
              selectedPetType: selectedPetType.value,
              "onUpdate:selectedPetType": _cache[0] || (_cache[0] = ($event: any) => ((selectedPetType).value = $event)),
              selectedBreed: selectedBreed.value,
              "onUpdate:selectedBreed": _cache[1] || (_cache[1] = ($event: any) => ((selectedBreed).value = $event)),
              selectedDate: selectedDate.value,
              "onUpdate:selectedDate": _cache[2] || (_cache[2] = ($event: any) => ((selectedDate).value = $event)),
              minDate: minDate.value,
              "onUpdate:minDate": _cache[3] || (_cache[3] = ($event: any) => ((minDate).value = $event)),
              maxDate: maxDate.value,
              "onUpdate:maxDate": _cache[4] || (_cache[4] = ($event: any) => ((maxDate).value = $event)),
              showCombi: tksOpsCombi.value,
              showSpecificPetType: showSpecificPetType.value,
              petTypes: petTypes.value,
              onShowTariffs: _cache[5] || (_cache[5] = ($event: any) => (showTariffs($event)))
            }, null, 8, ["selectedPetType", "selectedBreed", "selectedDate", "minDate", "maxDate", "showCombi", "showSpecificPetType", "petTypes"]))
          : _createCommentVNode("", true),
        (!tksOpsCombi.value || hideCombiFilter.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(HeadlineComponent, {
                petName: props.petName,
                liability: props.liability,
                productGroup: productGroup.value,
                selectedPetType: selectedPetType.value
              }, null, 8, ["petName", "liability", "productGroup", "selectedPetType"]),
              _createVNode(TableHeadComponent, {
                product: _ctx.product,
                selectedDate: selectedDate.value,
                liability: props.liability,
                defaultProduct: defaultProduct.value,
                highlightDefaultProduct: highlightDefaultProduct.value,
                productGroup: productGroup.value,
                onSelectProduct: _cache[6] || (_cache[6] = ($event: any) => (selectProduct($event)))
              }, null, 8, ["product", "selectedDate", "liability", "defaultProduct", "highlightDefaultProduct", "productGroup"]),
              _createVNode(TableContentComponent, {
                productGroup: productGroup.value,
                highlightDefaultProduct: highlightDefaultProduct.value,
                defaultProduct: defaultProduct.value,
                liability: props.liability
              }, null, 8, ["productGroup", "highlightDefaultProduct", "defaultProduct", "liability"]),
              (props.showBottomButtons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup.value.products, (product, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "table-head-column"
                      }, [
                        _createVNode(TableColumnHeadComponent, {
                          product: product,
                          selectedDate: selectedDate.value,
                          liability: props.liability,
                          defaultProduct: defaultProduct.value,
                          forceMobile: true,
                          index: index,
                          onSelectProduct: ($event: any) => (selectProduct(product))
                        }, null, 8, ["product", "selectedDate", "liability", "defaultProduct", "index", "onSelectProduct"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})